import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function CommercialClubPage() {
    const navigate = useNavigate();
    const [flipped, setFlipped] = useState(false);
    const slots = 4;

    return (
        <div style={{ height: '100vh', width: '100vw', background: 'radial-gradient(circle at center, #27272a, #000000)', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', perspective: 1000 }}>

            <div style={{ textAlign: 'center', marginBottom: 60 }}>
                <div style={{ fontSize: '1rem', textTransform: 'uppercase', letterSpacing: 5, color: '#fbbf24', marginBottom: 10 }}>Membres Uniquement</div>
                <h1 style={{ fontSize: '4rem', fontWeight: 900, background: 'linear-gradient(to right, #fbbf24, #d97706)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', margin: 0 }}>LE CLUB PRIVÉ</h1>
            </div>

            {/* 3D CARD CONTAINER */}
            <div
                onClick={() => setFlipped(!flipped)}
                style={{
                    width: 500, height: 300, cursor: 'pointer', position: 'relative', transformStyle: 'preserve-3d',
                    transition: 'transform 0.8s', transform: flipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
                }}
            >
                {/* FRONT */}
                <div style={{
                    position: 'absolute', inset: 0, backfaceVisibility: 'hidden', borderRadius: 24, padding: 40,
                    background: 'linear-gradient(135deg, #18181b, #09090b)', border: '1px solid #27272a',
                    boxShadow: '0 20px 50px rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ fontSize: '1.5rem', fontWeight: 700, color: 'white' }}>InfoColab</div>
                        <div style={{ fontSize: '2rem' }}>🗝️</div>
                    </div>
                    <div style={{ display: 'flex', gap: 20 }}>
                        <div style={{ width: 50, height: 35, background: 'linear-gradient(45deg, #fce7f3, #db2777)', borderRadius: 6 }} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
                        <div style={{ fontFamily: 'monospace', fontSize: '1.5rem', letterSpacing: 2, color: 'rgba(255,255,255,0.8)' }}>
                            **** **** **** 8888
                        </div>
                        <div style={{ fontSize: '0.9rem', opacity: 0.5 }}>MEMBRE BLACK</div>
                    </div>
                </div>

                {/* BACK */}
                <div style={{
                    position: 'absolute', inset: 0, backfaceVisibility: 'hidden', borderRadius: 24, padding: 40,
                    background: 'linear-gradient(135deg, #18181b, #09090b)', border: '1px solid #fbbf24', transform: 'rotateY(180deg)',
                    boxShadow: '0 20px 50px rgba(251, 191, 36, 0.1)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
                }}>
                    <h3 style={{ color: '#fbbf24', fontSize: '1.5rem', marginBottom: 20 }}>AVANTAGES EXCLUSIFS</h3>
                    <ul style={{ listStyle: 'none', padding: 0, textAlign: 'left', display: 'flex', flexDirection: 'column', gap: 10, fontSize: '1.1rem' }}>
                        <li>⚡ Support Prioritaire (WhatsApp)</li>
                        <li>🚀 Accès aux Bêtas Google</li>
                        <li>🥂 Invitation Soirées Réseau</li>
                        <li>💎 -20% sur les nouveaux modules</li>
                    </ul>
                </div>
            </div>

            <div style={{ marginTop: 60, textAlign: 'center' }}>
                <p style={{ fontSize: '1.2rem', opacity: 0.7, marginBottom: 20 }}>
                    Il ne reste que <strong style={{ color: 'white' }}>{slots} places</strong> pour ce trimestre.
                </p>
                <button onClick={() => navigate('/commercial/sign')} style={{ padding: '20px 50px', background: 'linear-gradient(90deg, #fbbf24, #d97706)', color: 'black', border: 'none', borderRadius: 50, fontSize: '1.5rem', fontWeight: 800, cursor: 'pointer', boxShadow: '0 0 30px rgba(245, 158, 11, 0.3)' }}>
                    REJOINDRE LE CLUB 🗝️
                </button>
            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'fixed', bottom: 30, right: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.2)', cursor: 'pointer' }}>Retour</button>
        </div>
    );
}
